// src/components/LanguageSelector.jsx
import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function LanguageSelector() {
  const { t, i18n } = useTranslation();  
  const [open, setOpen] = useState(false);
  const current = i18n.resolvedLanguage || i18n.language || "fr";

  const label = useMemo(
    () => (current === "fr" ? "FR" : "EN"),
    [current]
  );

  const change = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
        className="px-3 py-2 rounded-md border border-gray-300 bg-white hover:bg-gray-50 text-sm"
      >
        {label} ▾
      </button>

      {open && (
        <div
          role="menu"
          className="absolute z-50 mt-2 w-64 rounded-md shadow-lg bg-white ring-1 ring-black/5"
          onMouseLeave={() => setOpen(false)}
        >
          <div className="p-4 text-sm text-gray-800">
            <div className="mb-3 font-medium">{t("lang.selector.language")}</div>
            <ul className="space-y-1">
              <li>
                <button
                  onClick={() => change("fr")}
                  className={`w-full text-left px-2 py-2 rounded hover:bg-gray-100 ${
                    current === "fr" ? "bg-gray-50 font-medium" : ""
                  }`}
                >
                  FR — Français
                </button>
              </li>
              <li>
                <button
                  onClick={() => change("en")}
                  className={`w-full text-left px-2 py-2 rounded hover:bg-gray-100 ${
                    current === "en" ? "bg-gray-50 font-medium" : ""
                  }`}
                >
                  EN — English
                </button>
              </li>
            </ul>

            {/* Sections décoratives comme sur ta capture */}
            <hr className="my-3" />
            <div className="text-gray-500">{t("lang.selector.location")}</div>
            <div className="mt-1 px-2 py-2 rounded border border-gray-200">
              {t("lang.selector.france")}
            </div>

            <div className="mt-3 text-gray-500">{t("lang.selector.currency")}</div>
            <div className="mt-1 px-2 py-2 rounded border border-gray-200">
              {t("lang.selector.eur")}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
